import { useState, useEffect } from 'react'
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react'
import styles from './EventMap.module.scss'

const mapStyles = {
  width: '100%',
  height: '100%',
  position: 'relative',
}

function EventMap({ map, google: googleAuthFromWrapper, title = '' }) {
  if (!map) return null

  const [showMap, setShowMap] = useState(true)
  const { lat, lng } = map

  // Reset hide/show when map data changes.
  useEffect(() => {
    setShowMap(true)
  }, [map])

  return (
    <>
      <div
        className={
          showMap
            ? `${styles.mapContainer} ${styles.open}`
            : styles.mapContainer
        }
      >
        {showMap && (
          <Map
            google={googleAuthFromWrapper}
            zoom={14}
            style={mapStyles}
            initialCenter={{
              lat,
              lng,
            }}
          >
            <Marker
              title={title}
              position={{
                lat,
                lng,
              }}
            />
          </Map>
        )}
      </div>
      <p
        role="button"
        className={styles.toggleLink}
        onClick={() => setShowMap(!showMap)}
      >
        {showMap ? 'Piilota kartta' : 'Näytä kartta'}
      </p>
    </>
  )
}

export default GoogleApiWrapper({
  apiKey: process.env.NEXT_PUBLIC_GOOGLE_API_KEY,
})(EventMap)
